import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectLicenseState = (store: StoreSchema) => store.license.cachedLicense.state